import React from "react";
import T from "prop-types";

export const Title = ({ text, className, onClick }) => {
  return (
    <div className={className} onClick={onClick}>
      {text}
    </div>
  );
};

Title.T = {
  text: T.string,
  className: T.string,
};

Title.defaultProps = {
  className: "titleDefaultCls",
};
